import React from 'react';
const comparisonRows = [{
  situation: 'Tu enfoque',
  without: 'Improvisás cada semana',
  with: 'Sistema listo mes a mes'
}, {
  situation: 'Las actividades',
  without: 'Las buscás en Google sin saber si sirven',
  with: 'Listas, organizadas y validadas'
}, {
  situation: 'Los hitos',
  without: 'No sabés si tu hijo va bien o no',
  with: 'Checklists claros por mes'
}, {
  situation: 'Las alertas',
  without: 'Las notás tarde o no las notás',
  with: 'Semáforo de alertas por etapa'
}, {
  situation: 'Tu confianza',
  without: 'Dudás de si lo hacés bien',
  with: 'Sabés exactamente qué hacer'
}, {
  situation: 'El tiempo',
  without: 'Horas buscando información dispersa',
  with: 'Todo en un solo sistema'
}, {
  situation: 'El desarrollo motor',
  without: 'Sin protocolo claro',
  with: 'Actividades por mes y área'
}, {
  situation: 'El lenguaje',
  without: 'Esperás y rezás',
  with: 'Protocolo de estimulación activo'
}];
const blocks = [{
  num: '01',
  emoji: '🧠',
  title: 'Protocolo de Neurodesarrollo Avanzado',
  desc: 'Estimulación neurológica profunda para potenciar al máximo cada etapa.'
}, {
  num: '02',
  emoji: '📋',
  title: 'Plan de Estimulación Semanal',
  desc: 'Semana a semana organizada con actividades específicas por área.'
}, {
  num: '03',
  emoji: '📱',
  title: 'Guía de Comunicación con el Bebé',
  desc: 'Scripts y guiones para hablarle, estimularlo y vincularte mejor cada día.'
}, {
  num: '04',
  emoji: '📊',
  title: 'Registro de Progreso Avanzado',
  desc: 'Seguimiento completo del desarrollo con indicadores claros por área.'
}];
const assets = ['Registro de hitos ampliado', 'Planilla de progreso semanal', 'Guía de señales de alerta extendida', 'Protocolo de des-estimulación', 'Actividades para papá y familia', 'Guiones de comunicación verbal', 'Calendario de estimulación mensual'];
export function ProBusiness() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(236,253,245) 0%, rgb(236,253,245) 15%, rgb(236,253,245) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-229">
      <div className="mx-auto max-w-4xl" data-id="element-230">
        {/* Header */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-231">
          ¿Qué agrega{' '}
          <span className="text-green-700" data-id="element-232">Neurodesarrollo Avanzado™?</span>
        </h2>
        <p className="text-center text-sm text-gray-500 mx-auto max-w-xl m-0 mb-8" data-id="element-233">
          El protocolo de estimulación profunda para madres que quieren ir un paso más allá y potenciar al máximo el desarrollo de su hijo.
        </p>

        {/* Scroll hint mobile */}
        <p className="text-xs text-gray-400 text-center mb-2 sm:hidden flex items-center justify-center gap-1" data-id="element-234">
          <span data-id="element-235">👆</span> Deslizá para ver la tabla completa
        </p>

        {/* Comparison Table */}
        <div className="mb-8 overflow-x-auto rounded-xl shadow-sm touch-pan-x" style={{
        border: '1px solid rgba(34, 197, 94, 0.2)',
        WebkitOverflowScrolling: 'touch'
      }} data-id="element-236">
          <div className="min-w-[560px] bg-white rounded-xl overflow-hidden" data-id="element-237">
            <div className="grid grid-cols-3 border-b border-gray-100" data-id="element-238">
              <div className="px-4 py-3 text-xs font-bold text-gray-500 uppercase tracking-wide" data-id="element-239">
                Situación
              </div>
              <div className="px-4 py-3 text-xs font-bold text-gray-400 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-240">
                ❌ Sin el Megapack
              </div>
              <div className="px-4 py-3 text-xs font-bold text-green-700 uppercase tracking-wide border-l border-gray-100 text-center" data-id="element-241">
                ✅ Con el Megapack
              </div>
            </div>
            {comparisonRows.map((row, i) => <div key={row.situation} className={`grid grid-cols-3 ${i < comparisonRows.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-242">
                <div className="px-4 py-3 text-xs font-bold text-gray-900" data-id="element-243">
                  {row.situation}
                </div>
                <div className="px-4 py-3 text-xs text-gray-500 border-l border-gray-100 bg-gray-50 text-center" data-id="element-244">
                  {row.without}
                </div>
                <div className="px-4 py-3 text-xs text-gray-900 border-l border-gray-100 text-center" style={{
              backgroundColor: 'rgb(240, 253, 244)'
            }} data-id="element-245">
                  {row.with}
                </div>
              </div>)}
          </div>
        </div>

        {/* Blocks */}
        <div className="bg-white border border-green-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-246">
          <div className="bg-green-700 px-5 py-3" data-id="element-247">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-248">
              🏆 NEURODESARROLLO AVANZADO™ INCLUYE:
            </h3>
          </div>
          <div className="divide-y divide-gray-100" data-id="element-249">
            {blocks.map(block => <div key={block.num} className="flex items-center gap-4 px-5 py-3" data-id="element-250">
                <span className="shrink-0 text-lg font-black text-green-700/30 w-8 text-center" data-id="element-251">
                  {block.num}
                </span>
                <div className="flex-1 min-w-0" data-id="element-252">
                  <span className="block text-sm font-black text-gray-900" data-id="element-253">
                    {block.emoji} {block.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-254">
                    {block.desc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>

        {/* Assets */}
        <div className="rounded-xl px-5 py-4" style={{
        backgroundColor: 'rgb(240, 253, 244)',
        border: '1px solid rgba(34, 197, 94, 0.2)'
      }} data-id="element-255">
          <p className="text-xs font-bold text-green-700 uppercase tracking-widest m-0 mb-3" data-id="element-256">
            📊 Assets incluidos:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-257">
            {assets.map(asset => <span key={asset} className="text-[11px] font-bold text-green-700 bg-white border border-green-700/20 rounded-full px-3 py-1" data-id="element-258">
                {asset}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}